module.exports = __webpack_public_path__ + "media/fonts/icomoon/fonts/icomoon-b167860b2340f6798d34a70e3b7046ae.woff";